module.exports = __webpack_public_path__ + "img/lock-white.7b0722b8.svg";